import {useDateTimeFormatter} from 'platform/locale';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import type {GridPdfExportCallback} from 'features/eag-grid';

import {createServiceCasePdfData} from '../utils/createServiceCasePdfData';

const PDF_FILENAME = 'service-cases.pdf';
const BRAND = 'OMNETIC';

export function useServiceCasePdfExport(): GridPdfExportCallback {
  const formatDateTime = useDateTimeFormatter();

  return async (context, signal) => {
    signal.throwIfAborted();
    const records = createServiceCasePdfData(context, {
      dateTime: (value) => formatDateTime('dateTimeShort', parseDate(value)),
    });
    const selection = i18n.t('page.datagrid.labels.numberOfSelectedRows', {
      selectedRows: records.length,
    });
    const exportedAt = formatDateTime('dateTimeShort', context.exportedAt);
    const {createServiceCasePdf} = await import('../utils/createServiceCasePdf');
    signal.throwIfAborted();
    const bytes = await createServiceCasePdf(
      {
        title: i18n.t('page.workshop.labels.serviceCases'),
        brand: BRAND,
        metadata: `${selection} | ${i18n.t('general.actions.export')} ${exportedAt}`,
        records,
      },
      signal
    );
    return {bytes, filename: PDF_FILENAME};
  };
}
